/**
 * @flow
 * @relayHash de4e4e5c633b22e979df2329cbc62887
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CopyUserLineItemsToContractInput = {
  clientMutationId?: ?string,
  contract_id: string,
  user_line_item_ids: $ReadOnlyArray<?string>,
};
export type Library_Contract_copyUserLineItemsToContractMutationVariables = {|
  input: CopyUserLineItemsToContractInput
|};
export type Library_Contract_copyUserLineItemsToContractMutationResponse = {|
  +copyUserLineItemsToContract: ?{|
    +contract: ?{|
      +contract_line_items: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +title: ?string,
            +description: ?string,
            +position: ?number,
            +price_cents: ?number,
            +price_currency: ?string,
            +quantity: ?number,
          |}
        |}>
      |}
    |}
  |}
|};
export type Library_Contract_copyUserLineItemsToContractMutation = {|
  variables: Library_Contract_copyUserLineItemsToContractMutationVariables,
  response: Library_Contract_copyUserLineItemsToContractMutationResponse,
|};
*/


/*
mutation Library_Contract_copyUserLineItemsToContractMutation(
  $input: CopyUserLineItemsToContractInput!
) {
  copyUserLineItemsToContract(input: $input) {
    contract {
      contract_line_items {
        edges {
          node {
            id
            title
            description
            position
            price_cents
            price_currency
            quantity
          }
        }
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CopyUserLineItemsToContractInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CopyUserLineItemsToContractInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "contract_line_items",
  "storageKey": null,
  "args": null,
  "concreteType": "ContractLineItemConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ContractLineItemEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "ContractLineItem",
          "plural": false,
          "selections": [
            v2,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "description",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "position",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "price_cents",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "price_currency",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "quantity",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "Library_Contract_copyUserLineItemsToContractMutation",
  "id": null,
  "text": "mutation Library_Contract_copyUserLineItemsToContractMutation(\n  $input: CopyUserLineItemsToContractInput!\n) {\n  copyUserLineItemsToContract(input: $input) {\n    contract {\n      contract_line_items {\n        edges {\n          node {\n            id\n            title\n            description\n            position\n            price_cents\n            price_currency\n            quantity\n          }\n        }\n      }\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Library_Contract_copyUserLineItemsToContractMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "copyUserLineItemsToContract",
        "storageKey": null,
        "args": v1,
        "concreteType": "CopyUserLineItemsToContractPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract",
            "storageKey": null,
            "args": null,
            "concreteType": "Contract",
            "plural": false,
            "selections": [
              v3
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "Library_Contract_copyUserLineItemsToContractMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "copyUserLineItemsToContract",
        "storageKey": null,
        "args": v1,
        "concreteType": "CopyUserLineItemsToContractPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "contract",
            "storageKey": null,
            "args": null,
            "concreteType": "Contract",
            "plural": false,
            "selections": [
              v3,
              v2
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '46f135548c7e335715dcbe6b92006ba2';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Contract/__generated__/Library_Contract_copyUserLineItemsToContractMutation.graphql.js